import { render, staticRenderFns } from "./Base64Uploader.vue?vue&type=template&id=422ae441&scoped=true"
import script from "./Base64Uploader.vue?vue&type=script&lang=js"
export * from "./Base64Uploader.vue?vue&type=script&lang=js"
import style0 from "./Base64Uploader.vue?vue&type=style&index=0&id=422ae441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ae441",
  null
  
)

export default component.exports